import React, { useState, useEffect } from "react";
import { FaArrowUp } from "react-icons/fa";
import { FindUs, Footer, Header, SpecialMenu } from "./container";
import { Navbar } from "./components";
import "./App.css";

const App = () => {
  const [showScrollTopButton, setShowScrollTopButton] = useState(false);

  useEffect(() => {
    // Function to check scroll position
    const checkScrollTop = () => {
      // Show button if page is scrolled more than 400px (adjust as needed)
      if (!showScrollTopButton && window.pageYOffset > 400) {
        setShowScrollTopButton(true);
      } else if (showScrollTopButton && window.pageYOffset <= 400) {
        setShowScrollTopButton(false);
      }
    };

    // Add event listener
    window.addEventListener("scroll", checkScrollTop);

    // Cleanup function to remove listener
    return () => window.removeEventListener("scroll", checkScrollTop);
  }, [showScrollTopButton]); // Re-run effect if showScrollTopButton changes

  const scrollTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <div>
      <Navbar />
      <Header />
      <SpecialMenu />
      <FindUs />
      {showScrollTopButton && (
        <button
          onClick={scrollTop}
          className="scrollTopButton"
          aria-label="Scroll to top"
        >
          <FaArrowUp />
        </button>
      )}
    </div>
  );
};

export default App;
